var map = {
	"./auth/auth.module": [
		"../../../../../src/app/routes/auth/auth.module.ts",
		"auth.module"
	],
	"./cart/cart.module": [
		"../../../../../src/app/routes/cart/cart.module.ts",
		"common",
		"cart.module"
	],
	"./checkout/checkout.module": [
		"../../../../../src/app/routes/checkout/checkout.module.ts",
		"common",
		"checkout.module"
	],
	"./company/company.module": [
		"../../../../../src/app/routes/company/company.module.ts",
		"company.module"
	],
	"./my-account/my-account.module": [
		"../../../../../src/app/routes/my-account/my-account.module.ts",
		"common",
		"my-account.module"
	],
	"./orders/orders.module": [
		"../../../../../src/app/routes/my-account/orders/orders.module.ts",
		"common",
		"orders.module"
	],
	"./products/products.module": [
		"../../../../../src/app/routes/products/products.module.ts",
		"common",
		"products.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main